import { recordPath, recordRoute } from '@/shared/registry'

/** Where the publishing group pages live. */
export const publishingGroupsPath = '/catalog/publishing-groups'
export const createPublishingGroupPath = `${publishingGroupsPath}/new`
export const publishingGroupRoute = recordRoute('catalog', 'publishing-groups')
export const editPublishingGroupRoute = `${publishingGroupRoute}/edit`

/** A publishing group's details page. */
export function publishingGroupPath(id: string): string {
  return recordPath('catalog', 'publishing-groups', id)
}

/** The base of Publishing Group Details' slots (`detailsSlots`). */
export const publishingGroupDetailsSlot = 'catalog.publishing-group-details'

/** The API's publishing group endpoints. */
export const publishingGroupsApi = '/catalog/v1/publishing-groups'

export function publishingGroupApi(id: string): string {
  return `${publishingGroupsApi}/${encodeURIComponent(id)}`
}

/** Where a group's courses, libraries and lab profiles are set, all at once. */
export function publishingGroupContentApi(id: string): string {
  return `${publishingGroupApi(id)}/content`
}

/** Where the organizations a group is published to are set, all at once. */
export function publishingGroupOrganizationsApi(id: string): string {
  return `${publishingGroupApi(id)}/organizations`
}

/** A course's Availability section: the groups holding it. */
export function coursePublishingGroupsApi(courseId: string): string {
  return `/catalog/v1/courses/${encodeURIComponent(courseId)}/publishing-groups`
}

/** What each publishing group action needs. */
export const readPublishingGroupsPermission = 'catalog.publishing-groups.read'
export const writePublishingGroupsPermission = 'catalog.publishing-groups.write'
export const deletePublishingGroupsPermission = 'catalog.publishing-groups.delete'
